import cagDischargePdf from '@/services/utils/pdf/cagDischargePdf';
import handleHospital from '@/services/modules/hospital';
import handleCompany from "@/services/modules/company";

const cagDischargePdfHelper = () => {
    const { exportToPDF } = cagDischargePdf();
    const { fetchSingleDischargeOrder } = handleHospital();
    const { fetchCompanyInfo } = handleCompany();

    let companyInfo = {};
    let dischargeInfo = {};

    const generatePdf = (admissionInfo, serviceId, companyId) => {
        let admissionQuery = getQuery(admissionInfo.id, companyId);

        Promise.all([
            fetchSingleDischargeOrder(admissionQuery, serviceId, 'discharge_order').then((res) => {
                if(res.status) dischargeInfo = res.data
            }),
            fetchCompanyInfo(companyId).then( (res) => {
                if(res.status) companyInfo = res.data;
            })
        ]).then(() => {
            exportToPDF(companyInfo, admissionInfo, dischargeInfo);
        }).catch((e) => {
            console.log(e);
        })
    }

    const getQuery = (admissionId, companyId) => {
        let query = `?company_id=${companyId}`;
        query += `&admission_id=${admissionId}`;
        query += `&discharge_type=cag_pci`;
        return query;
    }

    return {
        generatePdf
    }
}

export default cagDischargePdfHelper;